// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-cta_container___kcjK","heading-container":"footer-cta_heading-container__7llKy","qr-code":"footer-cta_qr-code__Xy1gW"};